export default __webpack_public_path__ + "static/review-bg-right-6e0172dc543c973c4bf50d7e9a5dcd14.svg";